import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { createSelector, sum } from "keautils";
import { selectores } from "app/main/std";
import { DatosBancoRep, validar as validarBanco } from "./banco";
import { DateTime } from "kea-react";

type Entity = models.NuevoRepModel;
interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

export function validar(x: Entity): kea.validation.Result<Entity> {
    const hoy = new Date();

    const rules: kea.validation.Rules<Entity> = {
        FechaPago: x => x.FechaPago ? x.FechaPago <= hoy ? true : "La fecha de pago no puede ser superior a la fecha actual" : "Obligatorio",
        FormaPago: kea.validation.required,
        IdSucursal: kea.validation.required,
        IdBanco: kea.validation.required,
        Banco: kea.validation.subrule(validarBanco)
    };

    return kea.validation.getErrors(rules, x);
}

export class DatosNuevoRep extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    errors = createSelector(this.value, x => validar(x));
    getField = kea.formfields(() => this.props, () => this.errors(this.props));
    montos = createSelector(this.value, x => x.Facturas);
    total = createSelector(this.montos, x => sum(x.map(y => y.Monto)));

    private onFechaPagoChange = async (x: Date | null | undefined) => {
        const hoy = new Date();
        if (x && x > hoy) {
            await kea.message("Fecha de pago invalida", "La fecha de pago no puede ser superior a la fecha actual", "error");
        }
        const viejo = this.props.value;
        var cambio: Partial<Entity> = { FechaPago: x || undefined };
        this.props.onChange({ ...viejo, ...cambio });
    }

    render() {
        const Sucursal = this.getField(selectores.Sucursal);
        const BancoSelector = this.getField(selectores.Banco);
        const FormaPago = this.getField(selectores.FormaPago);
        const Fecha = this.getField(kea.DateTime);
        const Banco = this.getField(DatosBancoRep);
        const Rep = this.getField(selectores.Rep);
        return (
            <div>
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <FormaPago field="FormaPago" label="Forma de pago" />,
                    <Fecha time={true} field="FechaPago" label="Fecha de pago" onChange={this.onFechaPagoChange} />,
                    <kea.Number readonly value={this.total(this.props)} label="Total" format="currency" />,
                    <BancoSelector field="IdBanco" label="Banco receptor" />
                ])}
                <Banco field="Banco" />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/pagos/form/index.tsx